<template>
  <b-modal :id="id" @hidden="clean" @ok="confirm" :title="title" :ok-title="button" header-bg-variant="dark" header-text-variant="light" ok-variant="dark">
    <b-form ref="wordlist_form">
      <b-form-group description="Название" :invalid-feedback="invalidName">
        <b-form-input v-model="name" type="text" :state="nameState" maxlength="50"/>
      </b-form-group>
      <b-form-group description="Тип">
        <b-form-select v-model="type" :options="wordlistTypes" value-field="value" text-field="text"/>
      </b-form-group>
      <b-form-group description="Файл" :invalid-feedback="invalidFile" v-if="!edit">
        <b-form-file v-model="file" accept="text/plain" placeholder="Выберите файл словаря" drop-placeholder="Перетащите файл сюда" :state="fileState"/>
      </b-form-group>
    </b-form>
  </b-modal>
</template>

<script>
import RekonoApi from '@/backend/RekonoApi'
export default {
  name: 'wordlistModal',
  mixins: [RekonoApi],
  props: {
    id: String,
    wordlist: Object,
    initialized: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    edit () {
      return (this.wordlist !== null)
    },
    title () {
      return this.wordlist !== null ? 'Редактировать словарь' : 'Новый словарь'
    },
    button () {
      return this.wordlist !== null ? 'Обновить словарь' : 'Создать словарь'
    }
  },
  data () {
    return {
      name: null,
      type: 'Endpoint',
      file: null,
      nameState: null,
      fileState: null,
      invalidName: 'Название словаря обязательно',
      invalidFile: 'Файл словаря обязателен',
      fileMaxSize: 500
    }
  },
  watch: {
    wordlist (wordlist) {
      if (this.initialized && wordlist !== null) {
        this.name = wordlist.name
        this.type = wordlist.type
      }
    }
  },
  methods: {
    check () {
      if (!this.validateName(this.name)) {
        this.nameState = false
        this.invalidName = this.name && this.name.length > 0 ? 'Неверное название словаря' : 'Название словаря обязательно'
      }
      if (!this.edit) {
        this.fileState = (this.file !== null)
        this.invalidFile = 'Файл словаря обязателен'
        if (this.fileState && this.file.size / (1024 * 1024) > this.fileMaxSize) {
          this.fileState = false
          this.invalidFile = 'Размер файла словаря не может превышать 500 МБ'
        }
      }
      return this.nameState !== false && this.fileState !== false
    },
    confirm (event) {
      event.preventDefault()
      if (this.check()) {
        const operation = this.edit ? this.update() : this.create()
        operation
          .then(() => { return Promise.resolve(true) })
          .catch(() => { return Promise.resolve(false) })
          .then(success => this.$emit('confirm', { id: this.id, success: success, reload: true }))
      }
    },
    create () {
      return this.post(
        '/api/wordlists/',
        this.getFormData(),
        this.name, 'Новый словарь создан успешно',
        true, { 'Content-Type': 'multipart/form-data' }
      )
    },
    update () {
      return this.put(`/api/wordlists/${this.wordlist.id}/`, { 'name': this.name, 'type': this.type }, this.name, 'Словарь обновлён успешно')
    },
    getFormData () {
      const data = new FormData()
      data.append('name', this.name)
      data.append('type', this.type)
      data.append('file', this.file)
      return data
    },
    clean () {
      this.name = null
      this.type = 'Endpoint'
      this.file = null
      this.nameState = null
      this.fileState = null
      this.$emit('clean')
    }
  }
}
</script>
